import { useMemo } from 'react'
import isSameDay from 'date-fns/isSameDay'
import format from 'date-fns/format'
import ja from 'date-fns/locale/ja'
import { FirebaseTimestampType } from 'firebase/index'

const useOrderLabel = (checkout_at: FirebaseTimestampType | undefined, updated_at: FirebaseTimestampType) => {
  return useMemo(() => {
    return checkout_at
      ? isSameDay(checkout_at.toDate(), new Date())
        ? `本日 ${format(checkout_at.toDate(), 'HH:mm')}の注文`
        : `${format(checkout_at.toDate(), 'M月d日(E) HH:mm', { locale: ja })}の注文`
      : isSameDay(updated_at.toDate(), new Date())
      ? `本日 ${format(updated_at.toDate(), 'HH:mm')}の注文`
      : `${format(updated_at.toDate(), 'M月d日(E) HH:mm', { locale: ja })}の注文`
  }, [checkout_at, updated_at])
}

export default useOrderLabel
